<!-- Sidebar -->
<nav class="sidebar-content" [class.height-sidebar]="!hasGlobalMessages()"
  [class.height-sidebar-global-message]="hasGlobalMessages()">
  <div class="d-flex flex-column gap-4">
    @for (item of sidebarService.sidebar(); track itemIndex; let itemIndex = $index) {
    @if (!item.hidden) {
    <details [open]="item.checked" name="subcategory">
      <summary [ngClass]="{'h6-regular': !item.checked, 'h6-bold': item.checked}"
        (click)="goToShopSection(item, $event)">
        {{item.name}}
      </summary>

      @if (item.sublist && item.sublist.length) {
      <ul class="mt-2">
        @for (sublist of item.sublist; track $index) {
        @if (!sublist.hidden) {
        <li class="h7-semibold" [class.subcategory-selected]="sublist.checked"
          (click)="goToShopSection(sublist, $event)">
          {{sublist.name}}
        </li>
        }
        }
      </ul>
      }

    </details>
    }
    }
  </div>
</nav>